import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import TableWrapper from '@/components/table/TableWrapper';
import DictionaryFieldTableColumns from './DictionaryFieldTableColumns';
import DictionaryFieldTableRows from './DictionaryFieldTableRows';
import DictionaryFieldTableFooter from './DictionaryFieldTableFooter';
import { datasetPermissions } from '../../sharing/constants';
import DictionaryDataUpload from '../../dictionaries/containers/DictionaryDataUpload';
import { canEditDataset } from '../../helper';
import { datasetPerms } from '../../sharing/state/state';
import { datasourceIngestEnabled } from '../../datasource/helper';
import { resolveCatalogueTemplate } from '../../catalogue/helper';

const DatasetDictionaryFieldTable = ({
  category,
  code,
  dictionaries,
  canEdit,
  canUpload,
  allowPmnTransfer,
}) => {
  let colSpan = 8;
  if (allowPmnTransfer) { colSpan += 1; }
  if (canEdit) { colSpan += 1; }

  return (
    <TableWrapper sticky celled className="aridhia-dataset-dictionary-table">
      <Table.Header fullWidth>
        {canUpload && (
          <Table.Row>
            <Table.HeaderCell colSpan={colSpan} className="aridhia-drag-drop">
              <DictionaryDataUpload category={category} code={code} dictionaryFieldTable />
            </Table.HeaderCell>
          </Table.Row>
        )}
        <DictionaryFieldTableColumns
          category={category}
          code={code}
          canEdit={canEdit}
          dictionaries={dictionaries}
          allowPmnTransfer={allowPmnTransfer}
        />
      </Table.Header>
      <Table.Body>
        <DictionaryFieldTableRows
          category={category}
          code={code}
          allowPmnTransfer={allowPmnTransfer}
          canEdit={canEdit}
        />
      </Table.Body>
      {canEdit && dictionaries.length > 0 && (
        <DictionaryFieldTableFooter category={category} code={code} colSpan={colSpan} />
      )}
    </TableWrapper>
  );
};

const mapStateToProps = ({
  datasets: {
    datasets,
    allowPmnTransfer,
  },
  auth: {
    role,
  },
  datasetDatasource: { features },
}, ownProps) => {
  const { dataset, datasourceFeatures } = resolveCatalogueTemplate(datasets, null, ownProps, {
    dictionaries: [],
    permissions: datasetPerms(),
  }, features);

  const dataIngestEnabled = datasourceIngestEnabled(datasourceFeatures);

  return (
    {
      canEdit: canEditDataset(dataset, role),
      dictionaries: dataset.dictionaries,
      canUpload: role.permissions.datasets.upload
        && dataset.permissions[datasetPermissions.INGEST_DATA]
        && dataset.dictionaries.length > 0 && !dataset.isEditing && dataIngestEnabled,
      allowPmnTransfer,
    }
  );
};

export default connect(mapStateToProps)(DatasetDictionaryFieldTable);
